import type { App } from 'vue';

import UiButton from './components/button';
import { UiIcon } from './components/icon';
import UiInput from './components/input';
import { UiSkeleton, UiSkeletonStatement, UiSkeletonTable } from './components/skeleton';
import { UiTabs } from './components/tabs';

const components = { UiButton, UiIcon, UiInput, UiSkeleton, UiSkeletonStatement, UiSkeletonTable, UiTabs };

const UiKit = {
  install(app: App) {
    Object.entries(components).forEach(([name, component]) => {
      //@ts-ignore
      app.component(name, component);
    });
  },
};

export default UiKit;
export { UiButton, UiIcon, UiInput, UiSkeleton, UiSkeletonStatement, UiSkeletonTable, UiTabs };
